import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ActionConfirmModal = ({ isOpen, toggle, title, message, confirmLabel, confirmColor, onConfirm }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered className="med-confirm-modal">
    <ModalBody className="text-center p-4 p-md-5">
      <div className="med-confirm-icon">
        <FontAwesomeIcon icon="trash-alt" />
      </div>
      <h4 className="med-confirm-title">{title}</h4>
      <p className="med-confirm-message mb-0">{message}</p>
    </ModalBody>
    <ModalFooter className="border-0 pt-0 px-4 pb-4 d-flex justify-content-center">
      <Button color="light" className="med-confirm-cancel" onClick={toggle}>
        <FontAwesomeIcon icon="times" className="mr-2" />
        Bekor qilish
      </Button>
      <Button color={confirmColor} className="med-confirm-submit" onClick={onConfirm}>
        <FontAwesomeIcon icon="trash-alt" className="mr-2" />
        {confirmLabel}
      </Button>
    </ModalFooter>
  </Modal>
);

ActionConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  onConfirm: PropTypes.func.isRequired
};

ActionConfirmModal.defaultProps = {
  title: 'Tasdiqlash',
  message: 'Ushbu amalni bajarishni tasdiqlaysizmi?',
  confirmLabel: "O'chirish",
  confirmColor: 'danger'
};

export default ActionConfirmModal;
